import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { ROLES } from 'constants/index';

const Home = ({ classes, user }) => {
  const { role, firstName, lastName, logged } = user;
  const stylist = role === ROLES.STYLIST || role === ROLES.TESTER;

  if (!logged) {
    return null;
  }

  const redirectPath = '/home';

  return (
    <main>
      {stylist ? (
        <Redirect to={redirectPath} />
      ) : (
        <>
          <div className={classes.messageTitle}>Welcome {`${firstName} ${lastName}`}</div>
          <div className={classes.message}>App for non stylists is coming soon...</div>
        </>
      )}
    </main>
  );
};

Home.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  user: PropTypes.shape({
    role: PropTypes.string,
    employeeNumber: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    logged: PropTypes.bool.isRequired,
  }),
};

Home.defaultProps = {
  classes: {},
  user: {
    role: '',
    employeeNumber: '',
    firstName: '',
    lastName: '',
    logged: false,
  },
};

export default Home;
